module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_005.png
// module id = 928
// module chunks = 0